import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RewardsLanding from "@/pages/RewardsLanding";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RewardsLanding />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
